import { render, staticRenderFns } from "./AddReportCustomComponentFooter.vue?vue&type=template&id=bd3f299c"
import script from "./AddReportCustomComponentFooter.vue?vue&type=script&lang=js"
export * from "./AddReportCustomComponentFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports